// extracted by mini-css-extract-plugin
export default {"postPageTagContainer":"Z8qDy","tagLabel":"axEgh","navigation":"M4F7v"};